import { render, staticRenderFns } from "./SizeButtonGroup.vue?vue&type=template&id=7a486a78"
import script from "./SizeButtonGroup.vue?vue&type=script&lang=js"
export * from "./SizeButtonGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports